export var transitions = {
    basicTime: '50ms',
    basicTimingFunction: 'cubic-bezier(0.28, 0.84, 0.42, 1)',
};
//# sourceMappingURL=transitions.js.map